import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade } from 'swiper/modules';

export function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}

function absoluteUrlFromPath(relativePath, appendQueryParams) {
  var absoluteUrl = window.location.protocol + '//' + window.location.host + '/' + relativePath;

  if (appendQueryParams) {
    absoluteUrl += window.location.search;
  }

  return absoluteUrl;
}

export function createProductUrlFromHandle(productHandle) {
  return absoluteUrlFromPath('products/' + productHandle, false);
}

export function getSiteCode() {
  switch(window.theme.permanent_domain) {
    case "space-furniture-au.myshopify.com":
      return "au";
    case "space-furniture-sg.myshopify.com":
      return "sg";
  }
}

document.addEventListener("DOMContentLoaded", function(e) {
  document.querySelectorAll('[data-swiper-slider]').forEach((slider) => {
    var userOptions = {};
    try {
      userOptions = JSON.parse(slider.dataset.swiper || '{}');
    } catch (err) {
      console.error('Invalid data-swiper JSON on', slider, err);
    }

    var paginationEl = slider.querySelector('.swiper-pagination');
    var prevEl = slider.querySelector('.swiper-button-prev');
    var nextEl = slider.querySelector('.swiper-button-next');

    var options = Object.assign(
      { speed: 500, modules: [Navigation, Pagination, EffectFade] },
      userOptions
    );

    if (paginationEl && !options.pagination) {
      options.pagination = { el: paginationEl, clickable: true };
    }
    if ((prevEl || nextEl) && !options.navigation) {
      options.navigation = { nextEl: nextEl, prevEl: prevEl };
    }

    new Swiper(slider, options);
  });
}, false);